export type TMetricsDownloadMetricKey =
  | 'financials'
  | 'burnrate'
  | 'headcount'
  | 'staffrate';

export type TMetricsDownloadFileFormat = 'excel' | 'csv';

export type TMetricsDownloadScope = 'studio' | 'portfolio' | 'finance';

/**
 * Dimension keys are open-ended (string) because they are use-case specific
 * and don't share a fixed union like metrics do.
 */
export type TDimensionKey = string;

export interface IDimensionOption {
  key: TDimensionKey;
  label: string;
}

export interface IMetricsDownloadConfig {
  scope: TMetricsDownloadScope;
  /** Required checkboxes — at least one must be selected to submit. */
  metricOptions: Array<{
    key: TMetricsDownloadMetricKey;
    label: string;
  }>;
  defaultMetrics: TMetricsDownloadMetricKey[];
  /** Optional checkboxes — form is submittable even if none are selected. */
  dimensionOptions?: IDimensionOption[];
  defaultDimensions?: TDimensionKey[];
}

export const STUDIOS_DOWNLOAD_FILE_FORMAT_OPTIONS: Array<{
  key: TMetricsDownloadFileFormat;
  label: string;
}> = [
  { key: 'excel', label: 'Excel' },
  { key: 'csv', label: 'CSV' },
];

export const STUDIOS_METRICS_DOWNLOAD_CONFIG: IMetricsDownloadConfig = {
  scope: 'studio',
  metricOptions: [
    { key: 'financials', label: 'Financials' },
    { key: 'burnrate', label: 'Burn Rate' },
    { key: 'headcount', label: 'Headcount' },
    { key: 'staffrate', label: 'Staff Rate' },
  ],
  defaultMetrics: ['financials', 'burnrate', 'headcount', 'staffrate'],
};

export const PORTFOLIO_METRICS_DOWNLOAD_CONFIG: IMetricsDownloadConfig = {
  scope: 'portfolio',
  metricOptions: [
    { key: 'burnrate', label: 'Burn Rate' },
    { key: 'headcount', label: 'Headcount' },
    { key: 'staffrate', label: 'Staff Rate' },
  ],
  defaultMetrics: ['burnrate', 'headcount', 'staffrate'],
};

export const LIVE_FINANCE_DOWNLOAD_CONFIG: IMetricsDownloadConfig = {
  scope: 'finance',
  metricOptions: [],
  defaultMetrics: [],
  dimensionOptions: [
    { key: 'by_platform', label: 'By Platform' },
  ],
  defaultDimensions: ['by_platform'],
};

// Backward-compatible aliases for Studios callers.
export type TStudiosDownloadMetricKey = TMetricsDownloadMetricKey;
export type TStudiosDownloadFileFormat = TMetricsDownloadFileFormat;
export const STUDIOS_DOWNLOAD_METRIC_OPTIONS = STUDIOS_METRICS_DOWNLOAD_CONFIG.metricOptions;
export const STUDIOS_DOWNLOAD_DEFAULT_METRICS = STUDIOS_METRICS_DOWNLOAD_CONFIG.defaultMetrics;
